module.exports = __webpack_public_path__ + "img/gallery-export.0d9cb706.svg";